import svgPaths from "../assets/star";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";


const useStyles = makeStyles(()=>({
    size: {
        width: '1.5rem',
        height: '1.5rem'
    }
}))

export function SparkleTabIcon({ className }: { className?: string }) {
    // Path Data
    // State 1 (Blue)
    const s1Big = svgPaths.p3fa6ed00;
    const s1Small = svgPaths.p37798080;

    const classes = useStyles();

    // State 2 (Pink)
    const s2Big = svgPaths.p1720f800;
    const s2Small = svgPaths.p7339d00;

    return (
        <div className={`relative ${classes.size || 'w-4 h-4'}`}>
            <svg
                className="block w-full h-full"
                fill="none"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 16 17"
            >
                <style>{`
          /* 
             Total Cycle: 10s
             0% -> 6% (600ms): Rotate 0->180, Scale 1->0.6, Morph S1->S2, Fade Blue->Pink
             6% -> 12% (600ms): Rotate 180->360, Scale 0.6->1, Morph S2->S1, Fade Pink->Blue
             12% -> 100%: Idle (at 360deg/0deg, Scale 1, S1, Blue)
          */

          @keyframes morph-big {
            0% { d: path('${s1Big}'); animation-timing-function: ease-in; }
            6% { d: path('${s2Big}'); animation-timing-function: ease-out; }
            12% { d: path('${s1Big}'); }
            100% { d: path('${s1Big}'); }
          }

          @keyframes move-big {
            0% { transform: rotate(0deg) scale(1); animation-timing-function: ease-in; }
            6% { transform: rotate(180deg) scale(0.6); animation-timing-function: ease-out; }
            12% { transform: rotate(360deg) scale(1); }
            100% { transform: rotate(360deg) scale(1); }
          }

          @keyframes morph-small {
            0% { d: path('${s1Small}'); animation-timing-function: ease-in; }
            6% { d: path('${s2Small}'); animation-timing-function: ease-out; }
            12% { d: path('${s1Small}'); }
            100% { d: path('${s1Small}'); }
          }

          @keyframes fade-out {
            0% { opacity: 1; animation-timing-function: ease-in; }
            6% { opacity: 0; animation-timing-function: ease-out; }
            12% { opacity: 1; }
            100% { opacity: 1; }
          }

          @keyframes fade-in {
            0% { opacity: 0; animation-timing-function: ease-in; }
            6% { opacity: 1; animation-timing-function: ease-out; }
            12% { opacity: 0; }
            100% { opacity: 0; }
          }

          .group-big {
            transform-origin: center;
            transform-box: fill-box;
            animation: move-big 10s linear infinite;
          }

          .anim-morph-big {
            animation: morph-big 10s linear infinite;
          }

          .anim-morph-small {
            animation: morph-small 10s linear infinite;
          }

          .anim-out {
            animation: fade-out 10s linear infinite;
          }

          .anim-in {
            animation: fade-in 10s linear infinite;
          }
        `}</style>
                <defs>
                    {/* --- State 1 Gradients (Blue) --- */}
                    <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_1_28" x1="11.998" x2="3.99431" y1="7.99606" y2="12.6631">
                        <stop stopColor="#7B61FF" />
                        <stop offset="1" stopColor="#46D6F9" />
                        <animateTransform attributeName="gradientTransform" type="rotate" from="0 8 8.5" to="360 8 8.5" dur="3s" repeatCount="indefinite" />
                    </linearGradient>
                    <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_1_28" x1="15.52" x2="11.826" y1="13.7711" y2="15.9251">
                        <stop stopColor="#7B61FF" />
                        <stop offset="1" stopColor="#46D6F9" />
                        <animateTransform attributeName="gradientTransform" type="rotate" from="0 13.7 14.8" to="360 13.7 14.8" dur="3s" repeatCount="indefinite" />
                    </linearGradient>

                    {/* --- State 2 Gradients (Pink) --- */}
                    <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_3_101" x1="5.73119" x2="2.14362" y1="0.878518" y2="7.15623">
                        <stop stopColor="#7B61FF" />
                        <stop offset="1" stopColor="#FF40AC" />
                        <animateTransform attributeName="gradientTransform" type="rotate" from="0 8 8.5" to="360 8 8.5" dur="3s" repeatCount="indefinite" />
                    </linearGradient>
                    <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_3_101" x1="11.2134" x2="13.6756" y1="13.9781" y2="12.542">
                        <stop stopColor="#7B61FF" />
                        <stop offset="1" stopColor="#FF40AC" />
                        <animateTransform attributeName="gradientTransform" type="rotate" from="0 13.7 14.8" to="360 13.7 14.8" dur="3s" repeatCount="indefinite" />
                    </linearGradient>
                </defs>

                {/* BIG STAR GROUP - Rotates 360 & Scales */}
                <g className="group-big">
                    {/* Layer 1: Blue Gradient + Morphing Shape */}
                    <path
                        className="anim-morph-big anim-out"
                        d={s1Big}
                        fill="url(#paint0_linear_1_28)"
                    />
                    {/* Layer 2: Pink Gradient + Morphing Shape */}
                    <path
                        className="anim-morph-big anim-in"
                        d={s1Big}
                        fill="url(#paint0_linear_3_101)"
                    />
                </g>

                {/* SMALL STAR GROUP - Static Position (Only Morphs) */}
                <g>
                    {/* Layer 1: Blue Gradient + Morphing Shape */}
                    <path
                        className="anim-morph-small anim-out"
                        d={s1Small}
                        fill="url(#paint1_linear_1_28)"
                    />
                    {/* Layer 2: Pink Gradient + Morphing Shape */}
                    <path
                        className="anim-morph-small anim-in"
                        d={s1Small}
                        fill="url(#paint1_linear_3_101)"
                    />
                </g>

            </svg>
        </div>
    );
}
